<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <origen-deuda-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import OrigenDeudaProvider from "../../../../providers/OrigenDeudaProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import OrigenDeudaForm from "../OrigenDeudaForm";
    
    


    export default {
        name: "OrigenDeudaCreate",
         
        components: { OrigenDeudaForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.origenDeuda.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    OrigenDeudaProvider.createOrigenDeuda(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createOrigenDeuda)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

